import React, { useCallback, useEffect, useState } from 'react'
import { useListContext } from 'react-admin'
import { createContext, useContext } from 'use-context-selector'

import { FilterContextProps } from './types'

export const FilterContext = createContext({} as FilterContextProps)

export const FilterProvider: React.FC = ({ children }) => {
  const { setFilters } = useListContext()
  const [openFilterModal, setOpenFilterModal] = useState<boolean>(false)

  const handleOnOpenFilterModal = useCallback(() => {
    setOpenFilterModal(true)
  }, [])

  const handleOnCloseFilterModal = useCallback(() => {
    setOpenFilterModal(false)
  }, [])

  useEffect(() => {
    setFilters({}, {})
  }, [])

  return (
    <FilterContext.Provider
      value={{
        setFilters,
        onOpenFilterModal: handleOnOpenFilterModal,
        onCloseFilterModal: handleOnCloseFilterModal,
        openFilterModal,
      }}
    >
      {children}
    </FilterContext.Provider>
  )
}

export const useFilterList = () => {
  const { setFilters, openFilterModal, onOpenFilterModal, onCloseFilterModal } =
    useContext(FilterContext)

  return {
    setFilters,
    openFilterModal,
    onOpenFilterModal,
    onCloseFilterModal,
  }
}
